import React, { useEffect, useState, useRef } from "react";
import { setGlobalLoading } from "../context/LoaderController";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  ROUTE_HOME,
  PAGE_TITLE_VIEW_RESULT,
  NO_STATE_SELECTED_MESSAGE,
  LOADING_RESULTS_MESSAGE,
  NO_RESULTS_FOUND_MESSAGE,
  ERROR_FETCH_RESULTS,
  CHOOSE_BALLOT_LABEL,
  BALLOT_OPTIONS,
  TABLE_HEADERS,
} from "../components/constants";
import {
  fetchDistricts,
  fetchAssemblies,
  fetchMandalams,
  fetchResult,
  fetchStateBallots,
} from "../services/api";
import "../App.css";

function SelectInput({ label, value, options, onChange, disabled }) {
  return (
    <div className="form-column">
      <label style={{ display: "block", marginBottom: 6 }}>{label}</label>
      <select
        className="form-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt.code || opt.id} value={opt.code || opt.id}>
            {opt.name || opt.title}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function GetResult() {
  const navigate = useNavigate();
  const { stateId: paramStateId, ballotId: paramBallotId } = useParams();

  const [storedStateName, setStoredStateName] = useState(
    localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_NAME) || ""
  );

  const [ballots, setBallots] = useState([]);

  const [stateId, setStateId] = useState(
    paramStateId ||
      localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE) ||
      ""
  );

  const [ballotId, setBallotId] = useState(paramBallotId || "");
  const [districtId, setDistrictId] = useState("");
  const [assemblyId, setAssemblyId] = useState("");
  const [blockId, setBlockId] = useState("");

  const [districts, setDistricts] = useState([]);
  const [assemblies, setAssemblies] = useState([]);
  const [blocks, setBlocks] = useState([]);

  const [rows, setRows] = useState([]);
  const [totalVotes, setTotalVotes] = useState("–");
  const [didNotVote, setDidNotVote] = useState("–");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const tableRef = useRef(null);
  const RESULTS_LIVE_FLAG = 1; // 0 = Not Live, 1 = Live\

  /* Sync state from URL */
 useEffect(() => {
  if (paramStateId) {
    setStateId(paramStateId);

    localStorage.setItem(
      LOCALSTORAGE_SELECTED_STATE_CODE,
      paramStateId
    );
  }
}, [paramStateId]);

useEffect(() => {
  if (paramBallotId) {
    setBallotId(paramBallotId);
  }
}, [paramBallotId]);

useEffect(() => {
  if (!paramStateId) return;

  setDistrictId("");
  setAssemblyId("");
  setBlockId("");
  setRows([]);

}, [paramStateId]);

  useEffect(() => {
    if (!stateId) return;

    fetchStateBallots(stateId)
      .then((data) => setBallots(data || []))
      .catch(console.error);
  }, [stateId]);

   /*Dropdown Config */
  const selectConfig = [
    {
      key: "districtId",
      label: "District",
      value: districtId,
      setValue: setDistrictId,
      options: districts,
      requiredFor: ["DP", "DG", "AS", "MD"],
      disabled: loading || districts.length === 0,
    },
    {
      key: "assemblyId",
      label: "Assembly",
      value: assemblyId,
      setValue: setAssemblyId,
      options: assemblies,
      requiredFor: ["AS", "MD"],
      disabled: loading || !districtId || assemblies.length === 0,
    },
    {
      key: "blockId",
      label: "Block",
      value: blockId,
      setValue: setBlockId,
      options: blocks,
      requiredFor: ["MD"],
      disabled: loading || !assemblyId || blocks.length === 0,
    },
  ];

  /*Reset dropdowns when Ballot changes */
  useEffect(() => {
    setRows([]);
    setTotalVotes("–");
    setDidNotVote("–");
    setError("");
    setDistrictId("");
    setAssemblies([]);
    setAssemblyId("");
    setBlocks([]);
    setBlockId("");
  }, [ballotId]);

  /** DISTRICT LOADING */
  useEffect(() => {
    if (!stateId) return;

    fetchDistricts(stateId).then(setDistricts).catch(console.error);

    setDistrictId("");
    setAssemblies([]);
    setAssemblyId("");
    setBlocks([]);
    setBlockId("");
    setRows([]);
    setTotalVotes("–");
    setDidNotVote("–");
  }, [stateId]);

  /** ASSEMBLY LOADING */
useEffect(() => {
  setTotalVotes("–");
  setDidNotVote("–");

  if (!districtId || !["AS", "MD"].includes(ballotId)) {
    setAssemblies([]);
    setAssemblyId("");
    setBlocks([]);
    setBlockId("");
    setRows([]);
    return;
  }

  fetchAssemblies(stateId, districtId)
    .then(setAssemblies)
    .catch(console.error);

  setAssemblyId("");
  setBlocks([]);
  setBlockId("");
  setRows([]);
}, [stateId, districtId, ballotId]);

  /** BLOCK LOADING */
  useEffect(() => {
    setTotalVotes("–");
    setDidNotVote("–");

    if (!assemblyId) {
      setBlocks([]);
      setBlockId("");
      setRows([]);
      return;
    }

    fetchMandalams(stateId, districtId, assemblyId)
      .then(setBlocks)
      .catch(console.error);

    setBlockId("");
    setRows([]);
  }, [stateId, districtId, assemblyId]);

  /** RESULTS LOADING */
  useEffect(() => {
    setTotalVotes("–");
    setDidNotVote("–");

if (!stateId || !ballotId) return;

if (["DP", "DG"].includes(ballotId) && !districtId) return;

if (ballotId === "AS" && (!districtId || !assemblyId)) return;

if (ballotId === "MD" && (!districtId || !assemblyId || !blockId)) return;

    setGlobalLoading(true);
    setError("");
    setRows([]);

    const payload = {
      stateCode: stateId,
      districtCode: districtId || "",
      assemblyCode: assemblyId || "",
      blockCode: ballotId === "MD" ? blockId : "",
      ballot: ballotId,
      mandalamCode: ballotId === "MD" ? blockId : "",
    };

    fetchResult(payload)
      .then((data) => {
        if (Array.isArray(data)) {
      const totalRow = data.find(
  (r) => String(r.CSN) === "999"
);

const totalVotesValue =
  totalRow && totalRow.VOTES != null
    ? Number(totalRow.VOTES)
    : null;

const filteredRows = data.filter(
  (r) => String(r.CSN) !== "999"
);

          setRows(filteredRows);

          if (totalVotesValue !== null) {
            const sum = filteredRows.reduce(
              (acc, row) => acc + (Number(row.VOTES) || 0),
              0
            );
            setTotalVotes(totalVotesValue);
            setDidNotVote(totalVotesValue - sum);
          }
        }
      })
      .catch(() => setError(ERROR_FETCH_RESULTS))
      .finally(() => setGlobalLoading(false));
  }, [stateId, districtId, assemblyId, blockId, ballotId]);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = 0;
    }
  }, [districtId, assemblyId, blockId, ballotId]);

useEffect(() => {
  if (!stateId) return;

  const newPath = ballotId
    ? `/get-result/${stateId}/${ballotId}`
    : `/get-result/${stateId}`;

  if (window.location.pathname !== newPath) {
    navigate(newPath);
  }
}, [stateId, ballotId, navigate]);

  if (!stateId) {
    return (
      <div className="main-container">
        <h2 className="section-title">
          {PAGE_TITLE_VIEW_RESULT}
        </h2>
        <p>
          {NO_STATE_SELECTED_MESSAGE.split("Home")[0]}
          <Link to={ROUTE_HOME}>Home</Link> page first.
        </p>
      </div>
    );
  }
  const STATE_MAP = {
  UK: "Uttarakhand",
  KA: "Karnataka",
  TN: "Tamil Nadu",
  MH: "Maharashtra",
  AP: "Andhra Pradesh",
  TS: "Telangana",
  GJ: "Gujarat",
  KL: "Kerala",
  RJ: "Rajasthan",
  MP: "Madhya Pradesh",
  PB: "Punjab"
};

  return (
    <div className="main-container">
      <h2 className="section-title">{PAGE_TITLE_VIEW_RESULT}</h2>

      {RESULTS_LIVE_FLAG === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            fontSize: "18px",
            fontWeight: "500",
          }}
        >
          The results page will be available soon.
        </div>
      ) : (
        <>
              <span className="iyc-badge">
  State: <strong>{STATE_MAP[stateId] || storedStateName || stateId}</strong>
</span>

          <div className="form-row" style={{ marginBottom: 16 }}>
            <SelectInput
              label={CHOOSE_BALLOT_LABEL}
              value={ballotId}
              options={ballots}
              onChange={(e) => setBallotId(e.target.value)}
            />
          </div>

          <div className="form-row" style={{ marginBottom: 16 }}>
            {selectConfig
              .filter((cfg) => cfg.requiredFor.includes(ballotId))
              .map((cfg) => (
                <SelectInput
                  key={cfg.key}
                  label={cfg.label}
                  value={cfg.value}
                  options={cfg.options}
                  onChange={(e) => cfg.setValue(e.target.value)}
                  disabled={cfg.disabled}
                />
              ))}
          </div>

          {loading && <p>{LOADING_RESULTS_MESSAGE}</p>}
          {error && <p className="error-text">❌ {error}</p>}

          {!loading && rows.length > 0 && (
            <>
              <div className="votes-summary-container">
                <div className="votes-summary-box">
                  <div className="votes-summary-label">Total Votes</div>
                  <div className="votes-summary-value">{totalVotes}</div>
                </div>

                <div className="votes-summary-box did-not-vote">
                  <div className="votes-summary-label">Did Not Vote</div>
                  <div className="votes-summary-value">{didNotVote}</div>
                </div>
              </div>

              <div className="scroll-top-container" ref={tableRef}>
                <div className="scroll-top-inner">
                  <table className="common-table">
                    <thead>
                      <tr>
                        {TABLE_HEADERS.map((header) => (
                          <th key={header}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r, i) => (
                        <tr key={i}>
                          <td>{r.CSN}</td>
                          <td>{r.MEMBER_ID}</td>
                          <td>
                            {r.FIRST_NAME} {r.LAST_NAME}
                          </td>
                          <td>{r.GENDER}</td>
                          <td>{r.CATEGORY}</td>
                          <td>{r.VOTES}</td>
                          <td>{r.POST}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {!loading && ballotId && rows.length === 0 && !error && (
            <p>{NO_RESULTS_FOUND_MESSAGE}</p>
          )}
        </>
      )}
    </div>
  );
}